import { useState } from "react";

const NAV_LINKS = [
  { href: "#feed", label: "最新动态" },
  { href: "#timeline", label: "事件脉络" },
  { href: "#channels", label: "频道分类" },
  { href: "#responses", label: "各方回应" },
  { href: "#hot", label: "热度榜" },
  { href: "#principles", label: "追踪准则" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <a href="#top" aria-label="沸点追踪 首页" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="leading-tight">
            <h1 className="font-heading text-lg font-black tracking-tight text-foreground-950">
              沸点追踪
            </h1>
            <span className="hidden text-[11px] font-medium text-foreground-500 sm:block">
              最新黑料 · 新进展新动态追踪
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-pulseDot rounded-full bg-background-50"></span>
            </span>
            订阅新料
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 lg:hidden" aria-label="移动端导航">
          <div className="container-x grid grid-cols-2 gap-1 py-3">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}